// extracted by mini-css-extract-plugin
module.exports = {"rating":"Rn-z","numberOfStars":"Sn-z","count":"Tn-z"};